import { connect } from 'react-redux';
import ResourceSelect from './ResourceSelect';
import {
  onSetResourceErrors,
  setSelectedResource,
} from '../../../../actions/orders';
import { customSelectStyles } from '../../../../utilities/helperUtility';

export default connect(
  ({
    product,
    order,
    settings: {
      bookingToken,
      setting = {},
      style = {},
      translation = {},
      defaultTranslation = {},
    },
  }) => ({
    kind: 'resources',
    resources: product.data.resources,
    selectedResource: order.selectedResource,
    selectedLocation: order.selectedLocation,
    errors: order.resourceValidationErrors,
    setting,
    styles: customSelectStyles(style.select, !!order.resourceValidationErrors),
    translation,
    bookingToken,
    defaultTranslation,
  }),
  (dispatch) => ({
    onSetErrors: (e) => dispatch(onSetResourceErrors(e)),
    setSelected: (a) => dispatch(setSelectedResource(a)),
  }),
)(ResourceSelect);
